// The notification inbox lives for the whole session, also across a winery switch: each entry
// remembers its winery so the bell only shows (and counts) the ones of the active winery.
// Entries with no winery (e.g. the changelog) belong to every winery.

// Data of an inbox entry, with the winery of the raw notification (top level or inside data) stamped on it.
export const withWineryId = (raw, extra = {}) => {
  const wineryId = raw?.winery_id ?? raw?.data?.winery_id;
  return { ...raw?.data, ...(wineryId != null && { winery_id: wineryId }), ...extra };
};

export const forActiveWinery = (items, activeWineryId) =>
  (items || []).filter((item) => {
    const wineryId = item?.data?.winery_id;
    return wineryId == null || Number(wineryId) === Number(activeWineryId);
  });
